import gql from 'graphql-tag'

export const updateCompany = ({ companyId, companyData }) => {
	return {
		mutation: gql`
			mutation updateSingleCompany(
				$company_id: bigint!
				$legal_name: String!
				$image_id: bigint!
				$phone: String!
				$style: String!
				$registry_code: String!
				$address: String!
				$company_name: String!
				$email: String!
			) {
				update_companies_by_pk(
					pk_columns: { id: $company_id }
					_set: {
						legal_name: $legal_name
						image_id: $image_id
						phone: $phone
						style: $style
						registry_code: $registry_code
						address: $address
						company_name: $company_name
						email: $email
					}
				) {
					id
				}
			}
		`,
		variables: {
			...companyData,
			company_id: companyId
		}
	}
}
